import css from 'styled-jsx/css';

const styles = css.global`/* mobile */
  #duvidas-perguntas {
    padding: 16px 0 32px;
    overflow: hidden;
  }

  #duvidas-perguntas .ctn {
    padding-right: 0;
    padding-left: 0;
  }

  .duvida-perguntas-box {
    margin-top: 32px;
    position: relative;
  }

  .duvida-div-search {
    display: flex;
    gap: 16px;
    padding: 12px 16px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    height: 48px;
    margin: 0 15px 35px 15px;
  }

  .duvida-div-search button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    border: navajowhite;
    width: 24px;
    height: 24px;
    justify-content: center;
  }

  .duvida-div-search img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: cover;
  }

  .duvida-div-search .close-search {
    width: 70%;
    height: 70%;
  }

  .duvida-div-search input {
    border: none;
    outline: none;
    color: #000;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    width: 100%;
  }

  .duvida-div-search input:focus {
    font-size: 16px;
  }

  .duvida-div-search input::placeholder {
    color: #cccccc;
  }

  .duvida-perguntas-temas {
    position: absolute;
    width: 100%;
    top: 90px;
  }

  .duvida-perguntas-title {
    text-align: center;
    margin: 40px auto 24px;
    font-family: 'SantanderHeadline';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    color: #000;
  }

  .duvida-perguntas-temas-btn {
    /* reset button */
    background: none;
    border: 0;
    background-color: #fff;
    padding: 0 16px;
    transition: background-color 350ms linear;
    cursor: pointer;
  }

  .duvida-perguntas-temas-btn div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #CCC;
    padding: 16px;
    color: #222;
    font-family: "SantanderText";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
  }

  .duvida-perguntas-content-temas {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .duvida-perguntas-temas-btn.selected {
    background-color: #F5F9FB;
  }

  .duvida-perguntas-respostas {
    margin-left: 100vw;
    width: 100vw;
    padding: 0 15px;
    min-height: 1222px;
    max-height: 1222px;
    position: relative;
    z-index: 200;
    background: #fff;
    transition: all 350ms linear;
    margin-top: -90px;
  }

  .duvida-perguntas-respostas.visible {
    margin-left: 0;
    max-height: none;
    min-height: 1222px;
    transition: all 350ms linear;
  }

  .duvida-perguntas-respostas .btn-voltar {
    display: flex;
    gap: 8px;
    align-items: center;
    color: #C00;
    font-family: "SantanderText";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    border-bottom: 1.081px solid #C00;
    padding-bottom: 16px;
    margin-bottom: 32px;
  }

  .duvida-perguntas-respostas .duvida-perguntas-content-title {
    margin: 8px 0 40px;
    color: #000;
    font-family: "SantanderText";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }

  .duvida-perguntas-content-respostas-acc {
    border-bottom: 1px solid #cccccc;
    width: 100%;
    margin-bottom: 24px;
  }

  .duvida-perguntas-content-respostas-title-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    
  }

  .duvida-perguntas-content-respostas-title {
    font-family: 'SantanderText';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #444;
    margin-right: 8px;
  }

  .duvida-perguntas-content-respostas-acc-text {
    font-family: 'SantanderText';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #444;
    height: 0px;
    visibility: hidden;
    opacity: 0;
  }

  .duvida-perguntas-content-respostas-acc-text a {
    font: inherit;
    color: #cc0000;
  }

  .duvida-perguntas-content-respostas-acc-text b {
    font-weight: 600;
  }

  .duvida-perguntas-content-respostas-acc.activated .duvida-perguntas-content-respostas-title-div,
  .duvida-perguntas-content-respostas-acc:hover .duvida-perguntas-content-respostas-title-div {
    cursor: pointer;
    /* background-color: #f0f0f0; */
  }

  .duvida-perguntas-content-respostas-acc
    .duvida-perguntas-content-respostas-title-div
    .duvida-perguntas-content-respostas-img {
    transition: all 0.3s ease;
  }

  .duvida-perguntas-content-respostas-acc.activated
    .duvida-perguntas-content-respostas-title-div
    .duvida-perguntas-content-respostas-img {
    transform: rotate(-180deg);
  }

  .duvida-perguntas-content-respostas-acc.activated .duvida-perguntas-content-respostas-acc-text {
    padding-bottom: 16px;
    animation: openAcc 0.3s forwards;
  }

  @keyframes openAcc {
    from {
      height: 0px;
      visibility: hidden;
      opacity: 0;
      /* padding: 0px 16px; */
    }

    to {
      height: auto;
      visibility: visible;
      opacity: 1;
      /* padding: 16px 16px; */
    }
  }

@media (min-width: 576px) {
  #duvidas-perguntas .ctn {
    padding-right: 15px;
    padding-left: 15px;
  }

  .duvida-div-search {
    margin: 0 0 35px 0;
  }

  .duvida-perguntas-respostas {
    padding: 0;
    max-width: 510px;
  }
}

@media (min-width: 768px) {
  .duvida-perguntas-respostas {
    max-width: 690px;
  }
}

/* desktop */
@media (min-width: 992px) {
  #duvidas-perguntas {
    margin-top: 40px;
    padding: 16px 0 48px;
  }

  /* .duvida-perguntas-box {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 40px;
    border-radius: 4px;
    border: 1px solid #d8d8d8;
    background: #fff;
    box-shadow: -12px 23px 20px 2px rgba(0, 0, 0, 0.25);
  } */

  .duvida-perguntas-title {
    margin: 0;
    color: #000;
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: SantanderHeadline;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px; /* 150% */
  }

  .duvida-div-search {
    display: flex;
    gap: 16px;
    padding: 12px 16px;
    border: 1px solid #cccccc;
    border-radius: 4px;
  }

  .duvida-div-search button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    border: navajowhite;
    width: 24px;
    height: 24px;
    justify-content: center;
  }

  .duvida-div-search img {
    width: 100%;
    height: 100%;
    cursor: pointer;
    object-fit: cover;
  }

  .duvida-div-search .close-search {
    width: 70%;
    height: 70%;
  }

  .duvida-div-search input {
    border: none;
    outline: none;
  }

  .duvida-div-search input::placeholder {
    color: #cccccc;
  }

  .duvida-perguntas-content {
    display: flex;
    gap: 56px;
  }

  .duvida-perguntas-temas {
    display: flex;
    flex-direction: column;
    gap: 21px;
    max-width: 286px;
    width: 100%;
    position: initial;
  }

  .duvida-perguntas-temas-btn div {
    padding: 16px 0;
  }
 
  /* .duvida-perguntas-temas-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    text-align: center;
    font-family: SantanderText;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; 
    border-radius: 4px;
    border: 1px solid #cc0000;
    color: #cc0000;
    background-color: #fff;
    transition: background-color 350ms linear;
  }

  .duvida-perguntas-temas-btn:hover {
    cursor: pointer;
    background-color: #fbd0d0;
  }

  .duvida-perguntas-temas-btn.selected {
    border: 1px solid #fff;
    color: #fff;
    background-color: #cc0000;
  } */

  /* .duvida-perguntas-temas-btn.selected:hover {
    background-color: #f14c4c;
  } */

  .duvida-perguntas-respostas {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 16px;
    max-height: 1005px;
    overflow-y: auto;
    max-width: 100%;
    margin-left: 0;
    padding: 0;
    margin-top: 0;
  }

  .duvida-perguntas-respostas.visible {
    margin-left: 0;
    max-height: none;
    min-height: auto;
  }

  
  .duvida-perguntas-respostas {
    scrollbar-width: thin; /* "auto" or "thin" */
    scrollbar-color: #cccccc transparent; /* scroll thumb and track */
  }

  .duvida-perguntas-respostas .btn-voltar {
    display: none;
  }

  .duvida-perguntas-respostas::-webkit-scrollbar-track {
    background: transparent;
  }
  .duvida-perguntas-respostas::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }
  .duvida-perguntas-respostas::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 4px;
  }

  .duvida-perguntas-content-respostas {
    display: flex;
    flex-direction: column;
  }

  .duvida-perguntas-content-respostas-acc {
    border-bottom: 1px solid #cccccc;
    width: 100%;
  }

  /* .duvida-perguntas-content-respostas-title-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    font-family: 'SantanderText';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; 
    transition: all 0.3s linear;
  } */

  /* .duvida-perguntas-content-respostas-acc.activated .duvida-perguntas-content-respostas-title-div,
  .duvida-perguntas-content-respostas-acc:hover .duvida-perguntas-content-respostas-title-div {
    cursor: pointer;
    background-color: #f0f0f0;
  } */

  .duvida-perguntas-content-respostas-acc
    .duvida-perguntas-content-respostas-title-div
    .duvida-perguntas-content-respostas-img {
    transition: all 0.3s ease;
  }

  .duvida-perguntas-content-respostas-acc.activated
    .duvida-perguntas-content-respostas-title-div
    .duvida-perguntas-content-respostas-img {
    transform: rotate(-180deg);
  }

  .duvida-perguntas-content-respostas-acc .duvida-perguntas-content-respostas-acc-text {
    font-family: SantanderText;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 140% */
    height: 0px;
    visibility: hidden;
    opacity: 0;
  }

  .duvida-perguntas-content-respostas-acc .duvida-perguntas-content-respostas-acc-text a {
    font-family: SantanderText;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #cc0000;
  }

  .duvida-perguntas-content-respostas-acc .duvida-perguntas-content-respostas-acc-text a:hover {
    text-decoration: underline;
  }

  .duvida-perguntas-content-respostas-acc .duvida-perguntas-content-respostas-acc-text b {
    font-weight: 600 !important;
  }

  .duvida-perguntas-content-respostas-acc.activated .duvida-perguntas-content-respostas-acc-text {
    padding: 16px 16px;
    animation: openAcc 0.3s forwards;
  }

  @keyframes openAcc {
    from {
      height: 0px;
      visibility: hidden;
      opacity: 0;
      padding: 0px 16px;
    }

    to {
      height: auto;
      visibility: visible;
      opacity: 1;
      padding: 16px 16px;
    }
  }
}
`;

export default styles;